
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.688.813H.75V23.5H19.5V5.344h-4.813V.812zm-4.72 18.812a5.594 5.594 0 100-11.188 5.594 5.594 0 000 11.188z","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M1.5 24C.673 24 0 23.327 0 22.5v-21C0 .673.673 0 1.5 0h12.025C17.097.002 20.002 2.908 20 6.478V22.5c0 .827-.673 1.5-1.5 1.5h-17zm0-23a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h17a.5.5 0 00.5-.5V6.478c0-.155-.007-.315-.022-.478H15.5c-.827 0-1.5-.673-1.5-1.5V1.022A5.063 5.063 0 0013.528 1H1.5zM15 4.5a.5.5 0 00.5.5h3.297A5.491 5.491 0 0015 1.203V4.5z","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M10 20c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6zm0-11.077A5.082 5.082 0 004.923 14c0 2.8 2.277 5.077 5.077 5.077S15.077 16.8 15.077 14 12.8 8.923 10 8.923z","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M10 17.125a.5.5 0 01-.5-.5v-3.918l-1.396 1.397a.5.5 0 11-.708-.708l2.25-2.251a.496.496 0 01.709.002l2.249 2.25a.5.5 0 11-.708.708L10.5 12.707v3.918a.5.5 0 01-.5.5z","fill":"#F2994A"}})])
          )
        }
      }
    